export default __webpack_public_path__ + "assets/images/4962cc14178acd3dff2791ecf2086950.jpg";